import config from '../constants/config';
import { BigNumber } from 'ethers';
import { useContractRead } from 'wagmi';

const useOldHoneyBalance = (
  walletAddress?: string
): [honeyBalance: BigNumber | undefined, readHoneyBalance: () => void] => {
  const { data, refetch } = useContractRead({
    addressOrName: config.contracts.oldHoneyTokenContract.address,
    contractInterface: config.contracts.oldHoneyTokenContract.interface,
    functionName: 'balanceOf',
    args: walletAddress,
  });

  return [data as BigNumber | undefined, refetch];
};

export default useOldHoneyBalance;
